module.exports = __webpack_public_path__ + "pin_lightpurple.c0fd4a.png";